import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ApplicationFeeUI from './ApplicationFeeUI.js'

class ApplicationFeeSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      applFeeStatusUpdated: false,
      transaction: null
    }
  }

  render() {
    return (
      <ApplicationFeeUI
        context={this.props.context}
        errorList={this.props.errorList}
        loan={this.props.loan}
        transaction={this.state.transaction}
        onRefreshClick={this.props.onRefreshClick}
        //
        applFeeStatusUpdated={this.state.applFeeStatusUpdated}
        onApplFeeStatusUpdateClick={() => { this.setState({ applFeeStatusUpdated: true }) }}
        onApplFeeStatusCancelClick={() => { this.setState({ applFeeStatusUpdated: false }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getTransaction(context)
  }

  getTransaction(context) {
    if (this.props.loan.applFeeTxnId != null) {
      let cacheManager = new CacheManager({
        resource: `/api/su/transactions/${this.props.loan.applFeeTxnId}`,
        cacheKey: CacheKeys.Transaction(this.props.loan.applFeeTxnId),
        callback: this.getTransactionCallback,
        ttlInSecs: 0
      })
      cacheManager.getObject2(context)
    }
  }

  getTransactionCallback = (response) => {
    this.setState({ errorList: response.errorList, transaction: response.transaction })
  }

}

export default withRouter(ApplicationFeeSF)
